
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AppPlayerNotesRootListIndex} from "@/models/app/player/notes/root/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerNotesRootListFormCreateIndexVue from "@/views/app/player/notes/root/list/form/create.vue";
import AppPlayerNotesRootListFormUpdateIndexVue from "@/views/app/player/notes/root/list/form/update.vue";
import AppPlayerNotesRootListFormRemoveIndexVue from "@/views/app/player/notes/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppPlayerNotesRootListFormCreateIndexVue,
    AppPlayerNotesRootListFormUpdateIndexVue,
    AppPlayerNotesRootListFormRemoveIndexVue,
  },
})
export default class AppPlayerNotesRootListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: store.getters.getAuthentication.id,
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  notes: Array<AppPlayerNotesRootListIndex> = [];

  async getNotes(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/notes`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.notes = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getNotes();
  }
}
